<!-- meeting can be detached and team becomes null, which will cause error in the auth check below -->
@if (meeting.team) {
    <div class="d-flex gap-1">
        <a *adaptIfAuthorised="ViewTeamMeetings; entity: meeting.team"
           [routerLink]="(teamMeetingLink$ | async)?.path"
           [queryParams]="(teamMeetingLink$ | async)?.queryParams"
           class="btn btn-blank meeting-shortcut-icon"
           adaptButtonIcon="fal fa-calendar-lines-pen"
           [adaptTooltip]="!showText ? 'Meeting page' : ''"
           data-test="meeting-page-shortcut">
            @if (showText) {
                <span>Team meetings</span>
            }
        </a>
        <a *adaptIfAuthorised="ViewTeamKanban; entity: meeting.team"
           [routerLink]="(teamWorkUrl$ | async)?.path"
           class="btn btn-blank meeting-shortcut-icon"
           adaptButtonIcon="fal fa-columns"
           [adaptTooltip]="!showText ? 'Team actions' : ''"
           data-test="meeting-tab-details-team-actions">
            @if (showText) {
                <span>Team actions</span>
            }
        </a>
        <!-- no need for *adaptIfAlto as they shouldn't have team objectives read -->
        <a *adaptIfAuthorised="ReadObjectivesForTeam; entity: meeting.team"
           [routerLink]="(teamObjectivesLink$ | async)?.path"
           class="btn btn-blank meeting-shortcut-icon"
           adaptButtonIcon="fal fa-users"
           [adaptTooltip]="!showText ? 'Team objectives' : ''">
            @if (showText) {
                <span>Team objectives</span>
            }
        </a>
        <a *adaptIfAuthorised="ReadPublicObjectives"
           [routerLink]="(orgObjectivesLink$ | async)?.path"
           class="btn btn-blank meeting-shortcut-icon"
           adaptButtonIcon="fal fa-cubes"
           [adaptTooltip]="!showText ? orgObjectivesText : ''">
            @if (showText) {
                <span>{{ orgObjectivesText }}</span>
            }
        </a>
        @if (meeting.team.teamType === TeamType.Leadership || meeting.team.teamType === TeamType.Owner) {
            <a *adaptIfAuthorised="ReadStrategicGoals"
               [routerLink]="(strategicGoalsUrl$ | async)?.path"
               class="btn btn-blank meeting-shortcut-icon"
               adaptButtonIcon="fal fa-bullseye"
               [adaptTooltip]="!showText ? 'Strategic goals' : ''">
                @if (showText) {
                    <span>Strategic goals</span>
                }
            </a>
        }
        @if (canEditTeamMeeting) {
            <button adaptButtonIcon="fal fa-money-check-edit"
                    class="ms-auto btn btn-blank meeting-shortcut-icon"
                    [adaptBlockingClick]="editMeetingAgenda"
                    [adaptBlockingClickParam]="meeting"
                    data-test="edit-agenda-button"
                    [adaptTooltip]="!showText ? 'Edit agenda' : ''">
                @if (showText) {
                    <span>Edit agenda</span>
                }
            </button>
        }
    </div>
}
